import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import MaskedInput from 'react-text-mask';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { addProducer } from '../../../../../support/store/AuthReducer';
import { ProcessButton, Header } from '../../../../components';
import validate from '../../../../../support/services/validation';
import { producerSchema } from '../../../../../support/services/validation/producers';
import { SpaceService } from '../../../../../support/services/api';

function AddOnlyConsumingProducer({ setShowForm }) {
  const dispatch = useDispatch();
  const [error, setError] = useState('Error de teste');
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setError({});
  }, [data]);

  const confirmProducer = async () => {
    setLoading(true);
    const producer = {
      register: {
        producerName: data?.producerName,
        companyName: data?.companyName,
        cnpj: data?.cnpj,
        stateRegister: data?.stateRegister,
      },
    };

    try {
      if (!data) throw Object({ noData: 'É necessário preencher os dados abaixo.' });

      await validate(producerSchema, data);

      const response = await SpaceService(true).create(producer);
      producer.id = response.producer.id;

      await dispatch(addProducer(producer));
      setLoading(false);
      setShowForm(false);
    } catch (err) {
      err.noData && toast(`${err.noData}`, { type: toast.TYPE.WARNING });
      setError({ [err.path]: err.message });
      setLoading(false);
    }
  };

  return (
    <div className="step-container">
      <section className="step-container">
        <Header goBack={() => setShowForm(false)} />
        <h1 className="step-title">
          Preencha os dados da empresa:
        </h1>
        <p className="step-subtitle">Salvaremos essas informações para futuros pedidos.</p>

        <ReactTooltip
          type="info"
          id="companyName"
          place="top"
          effect="solid"
          multiline
          className="tooltip"
        >
          É o nome de registro da empresa. Também conhecido como Nome Comercial, Denominação Social ou Firma Empresarial
        </ReactTooltip>

        <div className="floating-label-input">
          <input
            data-tip
            data-for="companyName"
            placeholder="Razão Social"
            id="companyName"
            type="text"
            name="companyName"
            value={data?.companyName ?? ''}
            onChange={(e) => setData({ ...data, companyName: e.target.value })}
          />
          <label htmlFor="companyName">Razão Social</label>
          <p className="error">{error.companyName}</p>
        </div>

        <ReactTooltip
          type="info"
          id="producerName"
          place="top"
          effect="solid"
          multiline
          className="tooltip"
        >
          Também conhecido como “Nome de Fachada” ou “Marca Empresarial”, é o nome popular de uma empresa, e pode ou não ser igual à sua razão social
        </ReactTooltip>

        <div className="floating-label-input">
          <input
            data-tip
            data-for="producerName"
            placeholder="Nome Fantasia"
            id="producerName"
            type="text"
            name="producerName"
            value={data?.producerName ?? ''}
            onChange={(e) => setData({ ...data, producerName: e.target.value })}
          />
          <label htmlFor="producerName">Nome Fantasia</label>
          <p className="error">{error.producerName}</p>
        </div>

        <div className="floating-label-input">
          <MaskedInput
            value={data?.cnpj ?? ''}
            onChange={(e) => {
              const cleaned = (`${e.target.value}`).replace(/\D/g, '');
              setData({ ...data, cnpj: cleaned });
            }}
            mask={[/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/]}
            placeholder="CNPJ"
            id="cnpj"
            type="text"
            name="cnpj"
          />
          <label htmlFor="cnpj">CNPJ</label>
          <p className="error">{error.cnpj}</p>
        </div>
        <div className="floating-label-input">
          <input
            value={data?.stateRegister ?? ''}
            onChange={(e) => {
              const cleaned = (`${e.target.value}`).replace(/\D/g, '');
              if (!e.target.value.length) delete data.stateRegister;
              else setData({ ...data, stateRegister: cleaned });
            }}
            placeholder="Inscrição Estadual"
            id="stateRegister"
            type="number"
            name="stateRegister"
          />
          <label htmlFor="stateRegister">Inscrição Estadual</label>
          <p className="error">{error.stateRegister}</p>
        </div>
      </section>
      <ProcessButton text={loading ? "Carregando..." : "Confirmar"} action={loading ? () => {} : () => confirmProducer()} />
    </div>
  );
}

export default AddOnlyConsumingProducer;
